module.exports = __webpack_public_path__ + "04_long_brown.882e9e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/04_long_brown.png
// module id = Ox2w
// module chunks = 0